import { z } from "zod/v4";

import { AiNodeContextSchema } from "../context-schemas";
import { BaseNodeExecutionResultSchema } from "../node-execution-result";

import {
  BaseNodeDefinitionConfigSchema,
  BaseNodeDefinitionSchema,
} from "./base-node";

// Zod schema for LLMChatNodeResult
export const LLMChatNodeResultSchema = BaseNodeExecutionResultSchema.extend({
  type: z.literal("llm-chat"),
  updatedContext: AiNodeContextSchema,
});

export const LLMChatNodeStringPromptConfigSchema = z.object({
  type: z.literal("text"),
  systemPrompt: z.string(),
  userPrompt: z.string(),
  temperature: z.number(),
  maxTokens: z.number(),
  maxSteps: z.number(),
});

// Zod schema for LLMChatNodeConfig
export const LLMChatNodeConfigSchema = BaseNodeDefinitionConfigSchema.and(
  LLMChatNodeStringPromptConfigSchema
);

// Zod schema for LLMChatNodeDefinition
export const LLMChatNodeDefinitionSchema = BaseNodeDefinitionSchema.extend({
  type: z.literal("llm-chat"),
  config: LLMChatNodeConfigSchema,
});

// Inferred types from Zod schemas
export type LLMChatNodeResult = z.infer<typeof LLMChatNodeResultSchema>;
export type LLMChatNodeDefinition = z.infer<typeof LLMChatNodeDefinitionSchema>;

// Export individual config types that may be used elsewhere
export type LLMChatNodeStringPromptConfig = z.infer<
  typeof LLMChatNodeStringPromptConfigSchema
>;
export type LLMChatNodeConfig = z.infer<typeof LLMChatNodeConfigSchema>;
